import { $Item } from "../types";
import { $LocationItem } from "./types";

export default function userShare(item: $Item): Promise<ShareData> {
  return new Promise((resolve) => {
    const _item = item as $LocationItem;
    resolve({ text: JSON.stringify(_item.latLng) });
  });
}
